var _line, _line2, _path, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 933,
    height: 185,
    viewBox: "0 0 933 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 118,
    x2: 917,
    y2: 118,
    stroke: "#0561F5",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 277,
    y1: 120,
    x2: 277,
    y2: 4,
    stroke: "#0561F5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.586 184.414C917.367 185.195 918.633 185.195 919.414 184.414L932.142 171.686C932.923 170.905 932.923 169.639 932.142 168.858C931.361 168.077 930.095 168.077 929.314 168.858L918 180.172L906.686 168.858C905.905 168.077 904.639 168.077 903.858 168.858C903.077 169.639 903.077 170.905 903.858 171.686L916.586 184.414ZM916 116L916 183L920 183L920 116L916 116Z",
    fill: "#0561F5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 279,
    y2: 2,
    stroke: "#0561F5",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.39c36ac0afd21ba5c6a38f2a361e0e22.svg";
export { ForwardRef as ReactComponent };